/**
 * SFrame212 — State-Level Tax Obligations (checklist-only).
 */

import { useParams } from 'react-router-dom';
import SettlementChecklistShell from '../settlement/SettlementChecklistShell';

const FRAME_ID = 'sframe-212';

const ITEMS = [
  {
    id: 'i11-1',
    title: 'Review State Estate Tax Laws',
    description:
      'Check whether your state has a separate estate or inheritance tax with its own exemption threshold.',
  },
  {
    id: 'i11-2',
    title: 'Check for Inheritance Tax',
    description:
      'Determine if beneficiaries owe state inheritance tax based on their relationship to the decedent.',
  },
  {
    id: 'i11-3',
    title: 'Verify State Final Income Tax',
    description:
      'Confirm whether a final state income tax return is required and the filing deadline.',
  },
];

export default function SFrame212() {
  const { estateId } = useParams<{ estateId: string }>();

  if (!estateId)
    return <div className="max-w-2xl mx-auto py-12 px-4 text-sm text-stone-600">Select an estate.</div>;

  return (
    <SettlementChecklistShell
      estateId={estateId}
      frameId={FRAME_ID}
      title="State-Level Tax Obligations"
      backTo={`/sframe-207/${estateId}`}
      backLabel="← Tax Filings"
      items={ITEMS}
      syncTaxDt4Guided
    />
  );
}
